import React, { FC } from "react";
import { Radio, RadioChangeEvent } from "antd";

interface IProps {
  setPeriodIndex: (value: number) => void;
  periodIndex: number;
  showAllOption?: boolean;
  show1Day?: boolean;
}

const ChartRangeSelector: FC<IProps> = ({ periodIndex, setPeriodIndex, showAllOption = true, show1Day = true }) => {
  return (
    <div>
      <Radio.Group
        defaultValue={periodIndex}
        buttonStyle="solid"
        size="small"
        onChange={(e: RadioChangeEvent) => setPeriodIndex(e.target.value)}
      >
        {show1Day && <Radio.Button value={0}>1d</Radio.Button>}
        <Radio.Button value={1}>1w</Radio.Button>
        <Radio.Button value={2}>1m</Radio.Button>
        <Radio.Button value={3}>3m</Radio.Button>
        <Radio.Button value={4}>6m</Radio.Button>
        <Radio.Button value={5}>1y</Radio.Button>
        {showAllOption && <Radio.Button value={6}>all</Radio.Button>}
      </Radio.Group>
    </div>
  );
};

export default ChartRangeSelector;
